import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=3b49d1fe&scoped=true&"
import script from "./personalCenter.vue?vue&type=script&lang=js&"
export * from "./personalCenter.vue?vue&type=script&lang=js&"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=3b49d1fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b49d1fe",
  null
  
)

export default component.exports